import React from 'react';
import PropTypes from 'prop-types';
import ActivateMemberForm from './activate-member-form';

class InactiveMember extends React.Component {
  static propTypes = {
    swicus_id: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    name: PropTypes.string,
    timezone: PropTypes.string
  }

  state = {
    isActivating: false
  }

  toggleIsActivating = (e) => {
    e.preventDefault();

    this.setState((prevState) => {
      return { isActivating: !prevState.isActivating };
    });
  }

  onCancel = (e) => {
    e.preventDefault();

    this.setState({ isActivating: false });
  }

  render() {
    const { isActivating } = this.state;
    const {
      swicus_id,
      email,
      name,
      timezone
    } = this.props;

    return (
      <li>
        <span className="right btn-links sm">
          { !isActivating && <a href="/" onClick={this.toggleIsActivating}>Activate</a> }
        </span>

        <strong>{email}</strong>
        <small className="soft">{name}</small>

        { isActivating &&
          <ActivateMemberForm
            swicus_id={swicus_id}
            email={email}
            name={name}
            timezone={timezone}
            onCancel={this.onCancel}
          />
        }
      </li>
    );
  }
};

export default InactiveMember;